import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { canonicalLocalProductUrl } from "./config";
import "@diffex/ui/tokens.css";
import "./styles.css";

const canonicalUrl = canonicalLocalProductUrl(window.location.href);

if (canonicalUrl) {
  window.location.replace(canonicalUrl);
} else {
  const root = document.getElementById("root");

  if (!root) {
    throw new Error("Product root element is missing");
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
